import React from "react";
import { Navigation } from "../components/Navigation";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";

export const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen bg-[#0a0a0f]">
      <Navigation />
      
      <main className="max-w-4xl mx-auto px-4 py-12" id="main-content">
        <Card className="bg-[#12121a] border-gray-800">
          <CardHeader>
            <CardTitle className="text-3xl font-bold text-white">
              📜 Privacy Policy e Cookie Policy
            </CardTitle>
            <p className="text-gray-500 mt-2">
              Ultimo aggiornamento: 6 Febbraio 2026
            </p>
          </CardHeader>
          
          <CardContent className="prose prose-sm max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-white mb-4">1. Titolare del Trattamento</h2>
              <p className="text-gray-400 mb-2">
                <strong>Edicola Cerasuolo</strong><br />
                Corso Europa 175<br />
                Villaricca (NA), Italia<br />
                Telefono: +39 347 080 8245<br />
                Email: amm@edicolavillaricca.com
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-white mb-4">2. Dati Personali Raccolti</h2>
              <p className="text-gray-400 mb-4">
                Raccogliamo i seguenti dati personali:
              </p>
              <ul className="list-disc pl-6 text-gray-400 space-y-2">
                <li><strong>Dati di contatto:</strong> nome, cognome, indirizzo email, numero di telefono</li>
                <li><strong>Dati di spedizione:</strong> indirizzo di consegna, città, CAP, paese</li>
                <li><strong>Dati di pagamento:</strong> gestiti da provider terzi (Stripe, Satispay)</li>
                <li><strong>Dati di navigazione:</strong> indirizzo IP, tipo di browser, pagine visitate</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-white mb-4">3. Finalità del Trattamento</h2>
              <p className="text-gray-400 mb-4">
                I tuoi dati personali vengono trattati per le seguenti finalità:
              </p>
              <ul className="list-disc pl-6 text-gray-400 space-y-2">
                <li>Processare e gestire i tuoi ordini</li>
                <li>Comunicare con te riguardo ai tuoi ordini</li>
                <li>Inviare newsletter (solo se hai dato il consenso)</li>
                <li>Migliorare i nostri servizi e la tua esperienza di navigazione</li>
                <li>Adempiere agli obblighi legali e fiscali</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-white mb-4">4. Cookie Utilizzati</h2>
              <p className="text-gray-400 mb-4">
                Il nostro sito utilizza i seguenti tipi di cookie:
              </p>
              
              <div className="mb-4">
                <h3 className="text-lg font-semibold text-gray-200 mb-2">Cookie Tecnici (Necessari)</h3>
                <p className="text-gray-400">
                  Questi cookie sono essenziali per il funzionamento del sito e non possono essere disabilitati. 
                  Includono cookie per la gestione del carrello, della sessione e delle preferenze.
                </p>
              </div>

              <div className="mb-4">
                <h3 className="text-lg font-semibold text-gray-200 mb-2">Cookie di Analisi</h3>
                <p className="text-gray-400">
                  Utilizziamo PostHog per analizzare come gli utenti utilizzano il nostro sito. 
                  Questi dati ci aiutano a migliorare l'esperienza utente. Puoi rifiutare questi cookie tramite il banner.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-white mb-4">Richieste pubblicitarie</h2>
              <p className="text-gray-400">Quando invii una richiesta per spazi pubblicitari raccogliamo nome, azienda, email, eventuale telefono, servizio richiesto e messaggio. Usiamo questi dati solo per valutare e rispondere alla richiesta, li archiviamo nell’area gestione protetta e inviamo una notifica all’email aziendale. Non li usiamo per newsletter o marketing senza un consenso separato.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-white mb-4">5. Condivisione dei Dati</h2>
              <p className="text-gray-400 mb-4">
                Condividiamo i tuoi dati solo con i seguenti partner fidati:
              </p>
              <ul className="list-disc pl-6 text-gray-400 space-y-2">
                <li><strong>Provider di pagamento:</strong> Stripe, Satispay (per processare i pagamenti)</li>
                <li><strong>Servizi di spedizione:</strong> corrieri per la consegna degli ordini</li>
                <li><strong>Provider di hosting:</strong> MongoDB Atlas, Cloudflare R2</li>
                <li><strong>Servizi di email:</strong> Gmail SMTP per comunicazioni transazionali</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-white mb-4">6. I Tuoi Diritti (GDPR)</h2>
              <p className="text-gray-400 mb-4">
                Secondo il Regolamento Generale sulla Protezione dei Dati (GDPR), hai diritto a:
              </p>
              <ul className="list-disc pl-6 text-gray-400 space-y-2">
                <li><strong>Accesso:</strong> richiedere una copia dei tuoi dati personali</li>
                <li><strong>Rettifica:</strong> correggere dati inesatti o incompleti</li>
                <li><strong>Cancellazione:</strong> richiedere la cancellazione dei tuoi dati ("diritto all'oblio")</li>
                <li><strong>Limitazione:</strong> limitare il trattamento in determinate circostanze</li>
                <li><strong>Portabilità:</strong> ricevere i tuoi dati in formato leggibile</li>
                <li><strong>Opposizione:</strong> opporti al trattamento per finalità di marketing</li>
                <li><strong>Revoca consenso:</strong> revocare il consenso in qualsiasi momento</li>
              </ul>
              <p className="text-gray-400 mt-4">
                Per esercitare i tuoi diritti, contattaci a: <a href="mailto:amm@edicolavillaricca.com" className="text-pink-400 underline">amm@edicolavillaricca.com</a>
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-white mb-4">7. Conservazione dei Dati</h2>
              <p className="text-gray-400">
                Conserviamo i tuoi dati personali per il tempo necessario a soddisfare le finalità per cui sono stati raccolti, 
                inclusi eventuali obblighi legali, contabili o di segnalazione. I dati degli ordini sono conservati per 10 anni 
                per adempiere agli obblighi fiscali.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-white mb-4">8. Sicurezza</h2>
              <p className="text-gray-400">
                Adottiamo misure tecniche e organizzative appropriate per proteggere i tuoi dati personali da accessi non autorizzati, 
                perdita, distruzione o alterazione. Tutti i pagamenti sono elaborati tramite connessioni sicure (HTTPS) e i dati 
                sensibili sono criptati.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-white mb-4">9. Modifiche alla Privacy Policy</h2>
              <p className="text-gray-400">
                Ci riserviamo il diritto di modificare questa Privacy Policy in qualsiasi momento. Le modifiche saranno pubblicate 
                su questa pagina con la data di aggiornamento. Ti consigliamo di controllare periodicamente questa pagina per 
                eventuali modifiche.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-white mb-4">10. Contatti</h2>
              <p className="text-gray-400">
                Per qualsiasi domanda riguardante questa Privacy Policy o il trattamento dei tuoi dati personali, 
                puoi contattarci:
              </p>
              <div className="bg-pink-500/10 border border-pink-500/30 rounded-lg p-4 mt-4">
                <p className="text-gray-200">
                  <strong>Edicola Cerasuolo</strong><br />
                  📍 Corso Europa 175, Villaricca (NA)<br />
                  📞 <a href="tel:+393470808245" className="text-pink-400 hover:underline">+39 347 080 8245</a><br />
                  📧 <a href="mailto:amm@edicolavillaricca.com" className="text-pink-400 hover:underline">amm@edicolavillaricca.com</a>
                </p>
              </div>
            </section>

            <div className="mt-8 pt-8 border-t border-gray-800">
              <h2 className="text-2xl font-semibold text-white mb-4">11. Accessibilità del Sito</h2>
              <p className="text-gray-400 mb-4">
                Edicola Cerasuolo si impegna a garantire che il proprio sito web sia accessibile a tutti gli utenti, 
                incluse le persone con disabilità. Il nostro sito è conforme agli standard internazionali di accessibilità:
              </p>
              <ul className="list-disc pl-6 text-gray-400 space-y-2 mb-4">
                <li><strong>WCAG 2.1 Level AA</strong> (Web Content Accessibility Guidelines) - Standard internazionale per l'accessibilità web</li>
                <li><strong>European Accessibility Act (EAA)</strong> - Direttiva Europea (UE) 2019/882 sull'accessibilità</li>
                <li><strong>Legge Stanca</strong> (Legge 9 gennaio 2004, n. 4) - Normativa italiana per l'accessibilità</li>
              </ul>
              <p className="text-gray-400 mb-4">
                <strong>Caratteristiche di accessibilità implementate:</strong>
              </p>
              <ul className="list-disc pl-6 text-gray-400 space-y-2 mb-4">
                <li>Navigazione completa da tastiera con focus visibile</li>
                <li>Skip navigation link per accedere rapidamente al contenuto principale</li>
                <li>Contrasto colori conforme (minimo 4.5:1)</li>
                <li>Testo alternativo (alt text) su tutte le immagini</li>
                <li>Etichette ARIA per tecnologie assistive e screen reader</li>
                <li>Struttura semantica HTML corretta</li>
                <li>Supporto zoom fino al 200% senza perdita di funzionalità</li>
                <li>Supporto per modalità riduzione movimento (prefers-reduced-motion)</li>
              </ul>
              <p className="text-gray-400 mb-4">
                <strong>Punteggio verificato:</strong> 90/100 su Google PageSpeed Insights (Accessibility)
              </p>
              <p className="text-gray-400">
                Se riscontri difficoltà nell'accesso o nell'utilizzo del sito, ti invitiamo a contattarci a{' '}
                <a href="mailto:amm@edicolavillaricca.com" className="text-pink-400 underline">amm@edicolavillaricca.com</a>{' '}
                o al telefono <a href="tel:+393470808245" className="text-pink-400 underline">+39 347 080 8245</a>. 
                Faremo del nostro meglio per fornirti le informazioni in un formato alternativo accessibile.
              </p>
            </div>

            <div className="mt-8 pt-8 border-t border-gray-800">
              <p className="text-sm text-gray-600 italic">
                ✅ Questa Privacy Policy è conforme al Regolamento Generale sulla Protezione dei Dati (GDPR) dell'Unione Europea (Regolamento UE 2016/679) 
                e al Codice in materia di protezione dei dati personali italiano (D.Lgs. 196/2003).
              </p>
            </div>
          </CardContent>
        </Card>

        <div className="text-center mt-8">
          <a href="/" className="inline-flex items-center gap-2 text-pink-400 hover:text-pink-300 font-medium">
            ← Torna alla Homepage
          </a>
        </div>
      </main>

      <footer className="bg-[#08080d] border-t border-gray-800 text-white py-12 mt-12" role="contentinfo">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <p className="text-gray-400">
            © 2024 Edicola Cerasuolo - Tutti i diritti riservati
          </p>
        </div>
      </footer>
    </div>
  );
};
